module.exports = __webpack_public_path__ + "img/StartOrderModalClosingIcon.7b898be2.svg";